import { DownloadOutlined } from '@ant-design/icons';
import { API } from '@eservices/shared/type';
import { Col, Row } from 'antd';
import { PrimaryButton } from '../../../components/Buttons';
import DescriptionItem from '../../../components/DescriptionItem';
import DownloadLink from '../../../components/DownloadLink';
import { useTranslation } from '../../../hooks/translationHook';
import styled from 'styled-components';

const StyledPrimaryButton = styled(PrimaryButton)`
    margin-top: 40px;
`;

const DownloadContainer = styled.div`
    text-align: center;
`;

interface EmailTaskDetailProps {
    companyId: string;
    task: API.EmailTaskDetails;
    taskConfiguration: API.TaskEmail;
}

const EmailTaskDetail: React.FC<EmailTaskDetailProps> = ({ companyId, task, taskConfiguration }) => {
    const { t, tCommon } = useTranslation('email_task');

    return (
        <>
            <Row>
                <Col span={24}>
                    <DescriptionItem title={t('recipient')} content={task.recipient} />
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <DescriptionItem title={t('sender')} content={taskConfiguration.sender.emailAddress} />
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <DescriptionItem title={t('display_name')} content={taskConfiguration.sender.displayName} />
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <DescriptionItem title={t('subject')} content={taskConfiguration.subject} />
                </Col>
            </Row>
            <Row>
                <Col span={12} offset={6}>
                    <DownloadContainer>
                        <DownloadLink
                            companyId={companyId}
                            source={API.FileSource.SENDING_EVENT}
                            location={task.location}
                            content={
                                <StyledPrimaryButton icon={<DownloadOutlined />}>
                                    {tCommon('download_document')}
                                </StyledPrimaryButton>
                            }
                        />
                    </DownloadContainer>
                </Col>
            </Row>
        </>
    );
};

export default EmailTaskDetail;
